import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type PullOrderFieldsFragment = { __typename?: 'OrderStateData', orderId: string, orderNumber: string, status: Types.OrderStatus, shipFromSiteLocationId: string, customer: { __typename?: 'OrderCustomerData', id: string, name: string }, lineItems: Array<{ __typename?: 'LineItemData', id: string, lineNumber: number, itemId: string, sku: string, name: string, quantity?: number | null, orderedQuantity?: number | null }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number }>, pulls: Array<{ __typename?: 'OrderLinePull', pullId: string, lineItemId: string, itemId: string, locationId: string, locationName?: string | null, grade: number, quantity: number, pulledBy: string, pulledAt: Types.TDateISO }> };

export type GetPullOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetPullOrderQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, orderNumber: string, status: Types.OrderStatus, shipFromSiteLocationId: string, customer: { __typename?: 'OrderCustomerData', id: string, name: string }, lineItems: Array<{ __typename?: 'LineItemData', id: string, lineNumber: number, itemId: string, sku: string, name: string, quantity?: number | null, orderedQuantity?: number | null }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number }>, pulls: Array<{ __typename?: 'OrderLinePull', pullId: string, lineItemId: string, itemId: string, locationId: string, locationName?: string | null, grade: number, quantity: number, pulledBy: string, pulledAt: Types.TDateISO }> } | null };

export type GetPullSubLocationsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.SubLocationDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPullSubLocationsQuery = { __typename?: 'Query', subLocations?: { __typename?: 'SubLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SubLocationDocument', locationId: string, siteLocationId: string, name: string, pickSequence?: number | null, status: Types.LocationStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPullItemAvailabilityQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.InventoryItemDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPullItemAvailabilityQuery = { __typename?: 'Query', inventoryItems?: { __typename?: 'InventoryItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'InventoryItemDocument', id: string, itemId: string, locationId: string, locationName: string, grade: number, availableQuantity: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPullLoadsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LoadDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LoadDocumentSortInput> | Types.LoadDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetPullLoadsQuery = { __typename?: 'Query', logisticsLoads?: { __typename?: 'LogisticsLoadsConnection', totalCount: number, nodes?: Array<{ __typename?: 'LoadDocument', loadId: string, loadNumber: number, shipDate: string, status: Types.LoadStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPullLoadOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LoadLineDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPullLoadOrdersQuery = { __typename?: 'Query', logisticsLoadLines?: { __typename?: 'LogisticsLoadLinesConnection', totalCount: number, nodes?: Array<{ __typename?: 'LoadLineDocument', loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const PullOrderFieldsFragmentDoc = new TypedDocumentString(`
    fragment PullOrderFields on OrderStateData {
  orderId
  orderNumber
  status
  shipFromSiteLocationId
  customer {
    id
    name
  }
  lineItems {
    id
    lineNumber
    itemId
    sku
    name
    quantity
    orderedQuantity
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
  }
  pulls {
    pullId
    lineItemId
    itemId
    locationId
    locationName
    grade
    quantity
    pulledBy
    pulledAt
  }
}
    `, {"fragmentName":"PullOrderFields"});
export const GetPullOrderDocument = new TypedDocumentString(`
    query GetPullOrder($orderId: String!) {
  order(orderId: $orderId) {
    ...PullOrderFields
  }
}
    fragment PullOrderFields on OrderStateData {
  orderId
  orderNumber
  status
  shipFromSiteLocationId
  customer {
    id
    name
  }
  lineItems {
    id
    lineNumber
    itemId
    sku
    name
    quantity
    orderedQuantity
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
  }
  pulls {
    pullId
    lineItemId
    itemId
    locationId
    locationName
    grade
    quantity
    pulledBy
    pulledAt
  }
}`);
export const GetPullSubLocationsDocument = new TypedDocumentString(`
    query GetPullSubLocations($where: SubLocationDocumentFilterInput, $first: Int, $after: String) {
  subLocations(where: $where, first: $first, after: $after) {
    nodes {
      locationId
      siteLocationId
      name
      pickSequence
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPullItemAvailabilityDocument = new TypedDocumentString(`
    query GetPullItemAvailability($where: InventoryItemDocumentFilterInput, $first: Int, $after: String) {
  inventoryItems(where: $where, first: $first, after: $after) {
    nodes {
      id
      itemId
      locationId
      locationName
      grade
      availableQuantity
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPullLoadsDocument = new TypedDocumentString(`
    query GetPullLoads($where: LoadDocumentFilterInput, $order: [LoadDocumentSortInput!], $first: Int) {
  logisticsLoads(where: $where, order: $order, first: $first) {
    nodes {
      loadId
      loadNumber
      shipDate
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPullLoadOrdersDocument = new TypedDocumentString(`
    query GetPullLoadOrders($where: LoadLineDocumentFilterInput, $first: Int, $after: String) {
  logisticsLoadLines(where: $where, first: $first, after: $after) {
    nodes {
      loadLineId
      loadId
      orderId
      orderNumber
      customerName
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPullOrder: build.query<GetPullOrderQuery, GetPullOrderQueryVariables>({
      query: (variables) => ({ document: GetPullOrderDocument, variables })
    }),
    GetPullSubLocations: build.query<GetPullSubLocationsQuery, GetPullSubLocationsQueryVariables | void>({
      query: (variables) => ({ document: GetPullSubLocationsDocument, variables })
    }),
    GetPullItemAvailability: build.query<GetPullItemAvailabilityQuery, GetPullItemAvailabilityQueryVariables | void>({
      query: (variables) => ({ document: GetPullItemAvailabilityDocument, variables })
    }),
    GetPullLoads: build.query<GetPullLoadsQuery, GetPullLoadsQueryVariables | void>({
      query: (variables) => ({ document: GetPullLoadsDocument, variables })
    }),
    GetPullLoadOrders: build.query<GetPullLoadOrdersQuery, GetPullLoadOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetPullLoadOrdersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetPullOrderQuery, useLazyGetPullOrderQuery, useGetPullSubLocationsQuery, useLazyGetPullSubLocationsQuery, useGetPullItemAvailabilityQuery, useLazyGetPullItemAvailabilityQuery, useGetPullLoadsQuery, useLazyGetPullLoadsQuery, useGetPullLoadOrdersQuery, useLazyGetPullLoadOrdersQuery } = injectedRtkApi;
